import errorMessages from 'plugins/i18n/errorMessages.en.ts'

export default {
	error: {
		errorMessages: errorMessages,
		insufficientPermission:
			'You do not have the required permission to continue',
		pageNotFound: 'The requested page was not found',
		unexpectedError: 'Sorry, an error has occurred',
	},
}
